module.exports = __webpack_public_path__ + "3060428e6771b71978c96948bf2aece4.png";